import { useTranslation } from 'react-i18next';
import LegalPageLayout from '@/components/legal/LegalPageLayout';

export default function LegalNotice() {
  const { t } = useTranslation();

  return (
    <LegalPageLayout
      title={t('legalNotice.title')}
      lastUpdated={t('legalNotice.lastUpdated')}
    >
      <section>
        <p className="lead text-lg text-gray-700 mb-8">
          {t('legalNotice.intro')}
        </p>
      </section>

      <section className="mb-8">
        <h2>{t('legalNotice.sections.operator.title')}</h2>
        <p>{t('legalNotice.sections.operator.name')}</p>
        <p>{t('legalNotice.sections.operator.address')}</p>
        <p>{t('legalNotice.sections.operator.country')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('legalNotice.sections.contact.title')}</h2>
        <p>
          {t('legalNotice.sections.contact.emailLabel')}:{' '}
          <a href="mailto:contact@mypink.contact">contact@mypink.contact</a>
        </p>
      </section>

      <section className="mb-8">
        <h2>{t('legalNotice.sections.responsible.title')}</h2>
        <p>{t('legalNotice.sections.responsible.content')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('legalNotice.sections.disclaimer.title')}</h2>

        <h3>{t('legalNotice.sections.disclaimer.content.title')}</h3>
        <p>{t('legalNotice.sections.disclaimer.content.text')}</p>

        <h3 className="mt-6">{t('legalNotice.sections.disclaimer.links.title')}</h3>
        <p>{t('legalNotice.sections.disclaimer.links.text')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('legalNotice.sections.copyright.title')}</h2>
        <p>{t('legalNotice.sections.copyright.content')}</p>
      </section>

      <section>
        <h2>{t('legalNotice.sections.affiliation.title')}</h2>
        <p>{t('legalNotice.sections.affiliation.content')}</p>
      </section>
    </LegalPageLayout>
  );
}
